import ManualTable from './ManualTable';

export default ManualTable;
